var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"500-page"},[_c('Page500')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }